import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";

@Injectable({
  providedIn: "root"
})
export class PackageEducationBranchService {
  constructor(private core: CoreService) { }
  list(): Observable<any> {
    return this.core.get(
      ServiceRoute.packageEducationBranch.list,
      new CommonHttpOption().headers
    );
  }

  add(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.packageEducationBranch.add,
      data,
      new CommonHttpOption().headers
    );
  }

  getBranches(educationPackageId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.packageEducationBranch.getBranches + educationPackageId,
      new CommonHttpOption().headers
    );
  }

  activeDeactiveEducationPackageinBranch(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.packageEducationBranch.activeDeactiveEducationPackageinBranch,
      data,
      new CommonHttpOption().headers
    );
  }

}
